// import { useRouter } from 'next/router'
import { BrowserRouter as Router, Link, NavLink } from "react-router-dom";
// import { NavHashLink } from 'react-router-hash-link';
import { DisplayRoute } from "../routes";
// import Image from 'next/image'
import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'

import useDeviceSize from '../components/useDeviceSize';
import {isSmallAtom} from '../atoms/atom.config.js'
import { mobileWidth, mobileHeight } from '../constants';

// assets
import closeIcon from '../assets/icons/button_close_blk.svg' //icon_close.svg'
import closeHoverIcon from '../assets/icons/button_close_hover.svg'


const ModalOverlay = forwardRef((props,ref) => {
// export default function MobileMenu(props) {
  //console.log(props);
  // const router = useRouter()
  //const names = ['Ada Lovelace', 'Grace Hopper', 'Margaret Hamilton'];

  //const [isSmall, setIsSmall] = useAtom(isSmallAtom);
  //const [showMenu, setShowMenu] = useState(true);
  //const [showMenu, setShowShareModal] = useAtom(showShareModalAtom);

  //const [width, height] = useDeviceSize();

  const [isFadingOut, setIsFadingOut] = useState(false);
  const closeBtnRef = useRef(null);

  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  const [isCloseHover, setIsCloseHover] = useState(false);

  const fadeOut = () => {
    if(isFadingOut) return;

    setIsFadingOut(true);
    // need a timeout here to remove the menu
    //{()=>fadeOut(setTimeout(()=>handleRemoveItem(),300))}
    setTimeout(() => {
      props.onModalClose()
      setIsFadingOut(false);
    },210);
  };

  const fadeIn = () => {
    if(!isFadingOut) return;

    setIsFadingOut(false);
  };

  //
  const isSafariDevice = () => {
    return (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad' || navigator.platform === 'iPhone'
  };
  const isChromeDevice = () => {
    //https://codepedia.info/detect-browser-in-javascript
    let userAgent = navigator.userAgent;
    return userAgent.match(/chrome|chromium|crios/i)
    // return (if(userAgent.match(/chrome|chromium|crios/i)){
    //   browserName = "chrome";
    // })
  };
  const isVideo = (url) => {
    let extension = url.split('.').pop();
    //console.log("MediaBackground", extension)
    return extension.toLowerCase() == "mp4" || extension.toLowerCase() == "m4v";
  };
  const hasVideo = () => {
    if(props.mediaFilename) {
      return isVideo(props.mediaFilename)
    }
    return false
  }

  const handleWindowResize = () => {
    setWidth(window.outerHeight);
    setHeight(window.innerHeight);
  }

  // const onTouchMove = evt => {
  //   // evt.preventDefault();
  //   //setHeight(window.innerHeight);
  //   console.log("onTouchMove", window.innerHeight);
  //   setHeight(window.innerHeight);
  // }

  useImperativeHandle(ref, () => {
    return { 
      //gotoSlideMod: (slideIndex) => gotoSlide(slideIndex),
      fadeOutMod: () => fadeOut()
    }
  });

  useEffect(() => {
    console.log("ModalOverlay:")
    //setIsFadingOut(false); 
    closeBtnRef.current.focus();

    // component is mounted and window is available
    // handleWindowResize();
    //window.addEventListener('touchmove', onTouchMove, { passive: true });
    // window.addEventListener('resize', handleWindowResize);
    // window.addEventListener('resize', _.debounce(handleWindowResize, 50));
    // unsubscribe from the event on component unmount
    // return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

 

  // fullscreen modal black background
  // FIXED: added overflow-y-auto so the inner content is scrollable not the outer
  const cn = `fixed block w-screen h-full top-0 left-0 z-[100] overflow-y-auto ${(isFadingOut) ? 'animate-fadeout' : 'animate-fadein'} ${(props.fullscreen) ? 'bg-black' : 'bg-black/20'}`;
  // smaller modal gray background
  // const cnSmall = `fixed block w-screen h-screen lg:w-[900px] lg:h-[600px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-rba-gray ${(isFadingOut) ? 'animate-fadeout' : 'animate-fadein'}`;
  const cnSmallInner = `${(!props.fullscreen) ? 'absolute block w-screen h-full lg:w-[900px] lg:h-[600px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-rba-gray-options' : 'absolute block w-screen h-full '}`;
  //w-[900px] h-[600px] 
  //<div className='max-w-[50rem] z-10 pr-[2rem] md:pr-[3rem] lg:pr-[3rem] xl:pr-[3rem] 2xl:pr-[3rem] pl-[2rem]' >
  const cnIpadSafariVideo = `${(isSafariDevice() && hasVideo()) ? 'top-[50px]' : ' top-0'}`;
  const styles = {
    //...constants.mainViewportHeightStyle,
    //'zIndex': 0,
    overflowScrolling: "touch", 
    WebkitOverflowScrolling: "touch"
  }
  //<div id={props.id} ref={ref} className="overflow-y-auto overflow-x-hidden w-full h-screen relative" style={styles}>
  return (
      // <div className={(props.fullscreen) ? cn : cnSmall} id="modal">
      <div className={cn} id="modal" style={styles}>
        {
          // android chrome shows the fixed footer when scrolling the modal- cant fix without changing to h-screen which breaks other stuff- easy fix is to just add a grey fullscreen background at bottom
          !props.fullscreen &&
          <div className="lg:hidden block fixed top-0 left-0 z-0 bg-rba-gray-options w-screen h-screen">          
          </div>
        }
        <div className={cnSmallInner} ref={closeBtnRef} tabIndex="0">
        
          {props.children} 
          <button tabIndex="0" className={cnIpadSafariVideo+" absolute right-0 w-[48px] h-[48px] cursor-pointer"} onClick={fadeOut} onMouseEnter={()=> setIsCloseHover(true)} onMouseLeave={()=> setIsCloseHover(false)}>
              {!isCloseHover ? <img src={closeIcon} alt="close" width={48} height={48}/> : <img src={closeHoverIcon} alt="close" width={48} height={48}/>}
              {/* <p className="text-sm">{height}<br/>{width}</p> */}
          </button>
        </div>
    </div>
  )
})


// custom overlay for landscape devices- showing a popup to swtich to portrait
const ModalOverlaySmall = forwardRef((props,ref) => {

  const [isFadingOut, setIsFadingOut] = useState(false);
  const closeBtnRef = useRef(null);

  //const [deviceWidth, deviceHeight] = useDeviceSize();
  //const [isSmall, setIsSmall] = useAtom(isSmallAtom);

  const fadeOut = () => {
    if(isFadingOut) return;

    setIsFadingOut(true);
    // need a timeout here to remove the menu
    //{()=>fadeOut(setTimeout(()=>handleRemoveItem(),300))}
    setTimeout(() => {
      props.onModalClose()
      setIsFadingOut(false);
    },210);
  };

  const fadeIn = () => {
    if(!isFadingOut) return;
    setIsFadingOut(false);
  };

  useImperativeHandle(ref, () => {
    return { 
      //gotoSlideMod: (slideIndex) => gotoSlide(slideIndex),
      fadeOutMod: () => fadeOut()
    }
  });

  useEffect(() => {
    console.log("ModalOverlaySmall:")
    //setIsFadingOut(false); 
    // this.refs.component.focus();
    closeBtnRef.current.focus();
  }, []);

  // fullscreen modal black background
  const cn = `fixed block w-screen h-full top-0 left-0 z-[100] ${(isFadingOut) ? 'animate-fadeout' : 'animate-fadein'} ${(props.fullscreen) ? 'bg-black' : 'bg-black/20'}`;
  // smaller modal gray background
  // const cnSmall = `fixed block w-screen h-screen lg:w-[900px] lg:h-[600px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-rba-gray ${(isFadingOut) ? 'animate-fadeout' : 'animate-fadein'}`;
  const cnSmallInner = `${(!props.fullscreen) ? 'absolute block w-screen h-full lg:w-[900px] lg:h-[600px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-black' : 'absolute block w-screen h-full '}`;
  
  return (
    // <div className={(props.fullscreen) ? cn : cnSmall} id="modal">
    <div className={cn} id="modal">
      {
        // android chrome shows the fixed footer when scrolling the modal- cant fix without changing to h-screen which breaks other stuff- easy fix is to just add a grey fullscreen background at bottom
        !props.fullscreen &&
        <div className="lg:hidden block fixed top-0 left-0 z-0 bg-rba-gray w-screen h-screen">          
        </div>
      }
      <div className={cnSmallInner} ref={closeBtnRef} tabIndex="0">
        {props.children} 
        <button tabIndex="0" className={" absolute top-0 right-0 p-[9px] w-[42px] h-[42px] cursor-pointer"} onClick={fadeOut}  >
            <img src={closeIcon} alt="close" width={42} height={42}/> 
        </button>
      </div>
  </div>
)
})

export {
    ModalOverlay,
    ModalOverlaySmall
}